webpackJsonp([1448787570647],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  padding: 48px;\n  min-height: calc(100vh - 96px);\n"], ["\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  padding: 48px;\n  min-height: calc(100vh - 96px);\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 1.3;\n  h1 {\n    font-weight: 600;\n    font-size: 24px;\n  }\n  h2 {\n    font-weight: 600;\n    margin-top: 20px;\n  }\n  ol, ul {\n    margin-left: 20px;\n  }\n  li, p {\n    margin-top: 12px;\n  }\n  > ul {\n    list-style: circle;\n  }\n  > ol {\n    list-style: decimal;\n    > ol {\n      list-style: lower-alpha;\n      > ol {\n        list-style: lower-roman;\n      }\n    }\n  }\n"], ["\n  line-height: 1.3;\n  h1 {\n    font-weight: 600;\n    font-size: 24px;\n  }\n  h2 {\n    font-weight: 600;\n    margin-top: 20px;\n  }\n  ol, ul {\n    margin-left: 20px;\n  }\n  li, p {\n    margin-top: 12px;\n  }\n  > ul {\n    list-style: circle;\n  }\n  > ol {\n    list-style: decimal;\n    > ol {\n      list-style: lower-alpha;\n      > ol {\n        list-style: lower-roman;\n      }\n    }\n  }\n"]);
	
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Doc = _styledComponents2.default.div(_templateObject2);
	
	function Template(_ref) {
	  var data = _ref.data;
	  var markdownRemark = data.markdownRemark;
	  var html = markdownRemark.html;
	
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(Doc, { dangerouslySetInnerHTML: { __html: html } })
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-doc-js-7786f22d737e73c5f633.js